<template>
  <div class="container">
    <div class="top-box">
      <img src="../../../static/images/index/bg2.png" />
      <div>参展商名单</div>
    </div>
    <div class="search-box">
      <div>
        <span class="iconfont icon-search"></span>
        <input
          placeholder="参展商搜索"
          v-model="keyword"
          type="text"
          @click="searchClick"
        />
      </div>
    </div>

    <div class="btm-box">
      <div scroll-y class="nav-box">
        <div
          class="nav_item"
          v-for="(item, index) in classifyList"
          :key="index"
          :class="item.HallNo == hallNo ? 'active' : ''"
          @click="classifyClick(item.HallNo, index)"
        >
          {{ item.HallNoDesc }} 馆
        </div>
      </div>

      <div class="detail-box">
        <div class="hall-box">
          <div class="hb_left">
            <div>
              <div class="hallName">
                <span>{{ hallInfo.HallNoDesc }}</span
                >馆
                <img
                  src="../../../static/images/index/icon01.png"
                  v-if="hallInfo.IsBrand"
                />
              </div>
              <div class="hallDesc">{{ hallInfo.DescFull }}</div>
            </div>
            <div class="hallTime" v-if="hallInfo.HallImgUpdateTime">
              数据截至日期：{{ hallInfo.HallImgUpdateTime }}
            </div>
          </div>
          <div class="hb_right" @click="previewImage(hallInfo.HallImg)">
            <img
              :src="hallInfo.HallImg"
              style="width: 120px; height: 200px; display: block"
            />
            <div><span class="iconfont icon-fangda"></span></div>
          </div>
        </div>
        <div class="tips">* 排名不分先后</div>
        <van-list
          v-model="loading"
          :finished="finished"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          :immediate-check="false"
          @load="getExhibitionCompanyList"
        >
          <div
            class="comBox"
            v-for="(item, index) in companyList"
            :key="index"
            @click.stop="toCompanyDetails(item.ApplyID)"
          >
            <van-image
              fit="contain"
              :src="item.Photo"
              error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
            />
            <div class="comRight">
              <div class="comName overFlowOne">{{ item.CompanyNameChi }}</div>
              <div class="desc overFlowOne">主营：{{ item.Product }}</div>
              <div class="notice">
                <span class="join">2026光亚展参展商</span>
                <span>{{ item.HallNo }}馆{{ item.PlaceNo }}</span>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>
<script>
import { List, Image, ImagePreview } from "vant";
import { exhibitionList, exhibitionCompanyList } from "@/api/index";
export default {
  name: "expoExhibitor",
  components: {
    "van-list": List,
    "van-image": Image,
    ImagePreview,
  },
  data() {
    return {
      hallNo: 0,
      hallInfo: "",
      keyword: "",
      classifyList: [],

      loading: false,
      finished: false,
      error: false,
      total: 0,
      pageIndex: 1,
      companyList: [],
    };
  },

  methods: {
    searchClick() {},
    //跳转详情
    toCompanyDetails(sid) {
      this.$router.push({ path: "/expoExhibitorDetail", query: { sid: sid } });
    },

    //预览图片
    previewImage(src) {
      ImagePreview({ images: [src], showIndex: false });
    },

    //左边导航
    classifyClick(hallno, index) {
      this.hallNo = hallno;
      this.hallInfo = this.classifyList[index];
      this.pageIndex = 1;
      this.companyList = [];
      this.$router.replace({
        path: "/expoExhibitor",
        query: { hallNo: hallno },
      });
      this.$nextTick(() => {
        this.getExhibitionCompanyList();
      });
    },

    //获取展馆
    getExhibitionList() {
      var that = this;
      exhibitionList({ IsOrder: 1 }).then((res) => {
        that.classifyList = res.Data.List;
        if (that.hallNo == 0) {
          that.hallNo = res.Data.List.length > 0 ? res.Data.List[0].HallNo : 0;
          that.hallInfo = res.Data.List.length > 0 ? res.Data.List[0] : 0;
          that.getExhibitionCompanyList();
        } else {
          var info = "";
          for (var i in that.classifyList) {
            if (that.classifyList[i].HallNo == that.hallNo) {
              info = that.classifyList[i];
            }
          }
          that.hallInfo = info;
          that.getExhibitionCompanyList();
        }
      });
    },

    getExhibitionCompanyList() {
      var that = this;
      var data = {
        HallNo: that.hallNo,
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
      };
      exhibitionCompanyList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.companyList = [...res.Data.List];
          } else {
            that.companyList = [...that.companyList, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.companyList.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },
  },
  mounted() {
    this.hallNo = this.$route.query.hallNo ? this.$route.query.hallNo : 0;
    this.getExhibitionList();
  },
};
</script>
<style lang="less" scoped>
.container {
  .top-box {
    width: 375px;
    height: 103px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    div {
      position: absolute;
      z-index: 1;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      font-size: 23px;
      font-weight: bold;
    }
  }
  .search-box {
    background-color: #fff;
    width: 100%;
    height: 50px;
    box-sizing: border-box;
    padding: 0 12px;
    border-bottom: 1px solid #ddd;
    display: flex;
    align-items: center;
    div {
      width: 100%;
      height: 30px;
      background-color: #f1f1f1;
      border-radius: 15px;
      display: flex;
      align-items: center;
      input {
        width: 85%;
        font-size: 11px;
        border: none;
        background-color: #f1f1f1;
      }
    }
    .iconfont {
      font-size: 12px;
      margin: 0 7px 0 13px;
      color: #999999;
    }
  }
  .btm-box {
    display: flex;
    align-items: flex-start;
    .nav-box {
      overflow-y: auto;
      height: calc(100vh - 153px);
      width: 80px;
      background-color: #f4f4f4;
      .nav_item {
        padding: 12px 5px 12px 12px;
        color: #333;
        font-size: 13px;
      }
      .active {
        color: #eb4e4e;
        background-color: #fff;
        position: relative;
        &::before {
          position: absolute;
          left: 0;
          top: 0;
          content: "";
          display: block;
          height: 100%;
          width: 5px;
          background-color: #eb4e4e;
        }
      }
    }
    .detail-box {
      overflow-y: auto;
      height: calc(100vh - 153px);
      width: 295px;
      padding: 0px 15px 15px 15px;
      box-sizing: border-box;
      .hall-box {
        margin-top: 20px;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        .hb_left {
          width: 140px;
          padding-top: 5px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-between;
          .hallName {
            color: #d62f2f;
            font-size: 15px;
            display: flex;
            align-items: flex-end;
            font-weight: bold;
            margin-bottom: 6px;
            span {
              font-size: 40px;
              line-height: 40px;
              margin-right: 5px;
            }
            img {
              width: 20px;
              height: 20px;
              margin-left: 5px;
            }
          }
          .hallDesc {
            color: #333333;
            font-size: 12px;
            margin-top: 10px;
          }
          .hallTime {
            color: #999999;
            font-size: 9px;
          }
        }
        .hb_right {
          width: 110px;
          height: 178px;
          border: 3px solid #f4f4f4;
          background-color: #f4f4f4;
          position: relative;
          div {
            position: absolute;
            z-index: 2;
            bottom: 0;
            right: 0;
            width: 23px;
            height: 23px;
            background: rgba(0, 0, 0, 0.4);
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .iconfont {
            font-size: 13px;
            color: #fff;
          }
        }
      }
      .tips {
        padding-top: 3px;
        color: #bbbbbb;
        font-size: 9px;
        text-align: right;
        border-top: 1px solid #dddddd;
      }
      .comBox {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 10px 0;
        position: relative;
        /deep/.van-image {
          display: block;
          width: 60px;
          height: 60px;
          border: 1px solid #eee;
        }
        .comRight {
          width: 190px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          border-bottom: 1px solid #ddd;
          padding: 2px 0px 10px 0px;
          .comName {
            font-size: 13px;
            color: #333;
            font-weight: bold;
          }
          .grayName {
            color: #999;
            font-weight: normal;
          }
          .desc {
            font-size: 11px;
            color: #999;
          }
          .notice {
            font-size: 9px;
            margin-top: 7px;
            display: flex;
            align-items: center;
            span {
              padding: 0 6px;
              text-align: center;
              line-height: 14px;
              height: 14px;
              border: 1px solid #9999cc;
              border-radius: 7px;
              color: #9999cc;
            }
            .join {
              color: #cc9999;
              border: 1px solid #cc9999;
              margin-right: 3px;
            }
          }
        }
      }
    }
  }
}
</style>
